import { graphql, useStaticQuery } from "gatsby";
import { getImage } from "gatsby-plugin-image";

import { ITeam } from "types";

export const useHomeTeam = () => {
  const data = useStaticQuery(graphql`
    query Team {
      prismicHomePage {
        data {
          team {
            team_image {
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 180, placeholder: BLURRED, height: 180)
                }
              }
            }
            team_name
            team_title
            team_linkedin {
              url
            }
            team_twitter {
              url
            }
            team_github {
              url
            }
            team_facebook {
              url
            }
            team_telegram {
              url
            }
          }
        }
      }
    }
  `);

  return data.prismicHomePage.data.team
    ?.map((el: any) =>
      el && el.team_image && el.team_name
        ? {
            image: getImage(el.team_image.localFile),
            name: el.team_name,
            title: el.team_title,
            socials:
              el.team_linkedin.url ||
              el.team_twitter.url ||
              el.team_github.url ||
              el.team_facebook.url ||
              el.team_telegram.url
                ? {
                    linkedin: el.team_linkedin.url,
                    twitter: el.team_twitter.url,
                    github: el.team_github.url,
                    facebook: el.team_facebook.url,
                    telegram: el.team_telegram.url,
                  }
                : undefined,
          }
        : null
    )
    .filter((el: ITeam | null) => el) as ITeam[] | undefined;
};
